import {Table, TableRow, TableCell, TableBody, Paper, TextField, Grid, Box } from "@material-ui/core"
import { withStyles, WithStyles } from '@material-ui/core/styles';
import React, { Component } from "react"
import Loader from "react-spinners/ClipLoader";
import { connect, ConnectedProps } from "react-redux"
import { RootState } from "../../reducers/rootReducer"
import store from "../..";
import { REACT_APP_APIM_URL } from "../../utilities/GlobalConstants";
import { tmtStyles } from "./TmtInformationStyle";
import "../../assets/styles/_thermalImageInformationBlock.scss";
import FurnaceSelector from "./FurnaceSelector";
import { ICameras } from "../../slices/cameraSlice";
import { getSelectedCameraDetails, getCoilgroups, getTemperatureUnit } from "../../configuration";
import { setCoilgroups } from '../../slices/coilGroupSlice'
import { getToken, isTMTCameraDeviation, ParseTemperatureValue } from "../../utilities/helperFunctions";
import { setNotificationConfiguration } from "../../slices/notificationConfigurationSlice";
import { AuthContextProps, withAuth } from "react-oidc-context";
interface ITmtInformationBlock extends WithStyles<typeof tmtStyles>{
}

interface ICameraSelctorProps {
    cameraData: ICameras[];
    isFurnaceSelectionDisabled?: boolean;
}

interface OIDCAuth {
    auth?: AuthContextProps
}
  

const mapStateToProps = (state: RootState) => {
    return {
        selectedCoilgroupImageName: state.coilGroup.selectedCoilgroupImageName,
        currentFurnace: state.furnace.current_asset_name,
        currCamera: state.camera.name,
        selectedDate: state.coil.selectedDate,
        coilGroups: state.coilGroup.coilGroups,
        furnaces: state.furnace,
        currentCameraId: state.camera.id,
        accessibleFeatures: state.features.accessibleFeatures,
        notificationConfiguration : state.notificationConfigurationState.notificationConfiguration,
        currentFurnaceId: state.scenarioSimulator.currentFurnaceId,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCoilgroups: (values: string[]) => dispatch(setCoilgroups(values)),
        setNotificationConfiguration: (notificationConfiguration: any[]) => dispatch(setNotificationConfiguration(notificationConfiguration))
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>;

type TmtInformationBlockReduxProps = PropsFromRedux & ITmtInformationBlock & ICameraSelctorProps & OIDCAuth;

type TmtInformationBlockState = {
    selectedCoilgroupImageName : string
    currCamera : string,
    selectedDate : Date,
    coil_details : {}
    max_maxtmt_over_furnacecell : string,
    tmt_threshold : string,
    tmt_threshold_overshoot_coilgroups : string[],
    coilGroups : string[],
    tmt_threshold_overshoot_frunacecell : string[],
    tmtBlockLoader : boolean,
    currentCameraId : string,
    cg_heat_distribution : string,
    furnace_heat_distribution : string,
    furnace_mode : string
}
class TmtInformationBlock extends Component<TmtInformationBlockReduxProps, TmtInformationBlockState>{

    constructor(props) {
        super(props);

        this.state = {
            selectedCoilgroupImageName: this.props.selectedCoilgroupImageName,
            currCamera: this.props.currCamera,
            selectedDate: this.props.selectedDate,
            coil_details : {},
            max_maxtmt_over_furnacecell : "",
            tmt_threshold : "",
            tmt_threshold_overshoot_coilgroups : [],
            coilGroups : this.props.coilGroups,
            tmt_threshold_overshoot_frunacecell : [],
            tmtBlockLoader : true,
            currentCameraId : this.props.currentCameraId,
            cg_heat_distribution : "",
            furnace_heat_distribution : "",
            furnace_mode : "N/A",
        }
    }

    getTMTThreshold = () => {
        // let out = this.props.cameraData?.filter((camera, i) => {
        //     if(this.state.currCamera == camera.camera_name){
        //         return camera.tmt_threshold_value     
        //     }                      
        // })
        // this.setState({tmt_threshold: out[0] ? out[0].tmt_threshold_value : "0"})
        
        if(this.props.accessibleFeatures.includes("NOTIFICATION_CNFIGURATION"))
        {
            if(this.props.notificationConfiguration.length <= 0)
            {
                this.getNotificationConfiguration()
            }
            else
            {
                this.setTMTThreshold(this.props.notificationConfiguration)
            }
        }
        else
        {
            let selectedCameraDetails = getSelectedCameraDetails(parseInt(this.props.currentCameraId));
            this.setState({tmt_threshold: selectedCameraDetails['tmt_threshold_value']})
        }
    }

    setTMTThreshold = (configuration) => {
        let notificationConfiguration = configuration
        let selectedFurnace  = this.props.furnaces.furnace_metrics.filter((furnace) => furnace.furnace_id == this.props.furnaces.current_furnace_id)
        let selectedFurnaceMode = selectedFurnace[0]['furnace_mode_name']
        let tmt_threshold_max = notificationConfiguration[0]['furnace maximum tmt'][selectedFurnaceMode]
        let cg_heat_distribution = notificationConfiguration[0]['CG heat distribution'][selectedFurnaceMode]
        let furnace_heat_distribution = notificationConfiguration[0]['Furnace heat distribution'][selectedFurnaceMode]
        let furnace_mode = selectedFurnace[0]['State']
        this.setState(
            {
                tmt_threshold : tmt_threshold_max,
                cg_heat_distribution : cg_heat_distribution,
                furnace_heat_distribution : furnace_heat_distribution,
                furnace_mode : furnace_mode
            }
        )
    }

    getNotificationConfiguration = () => {
        getToken(this.props.auth).then((accessToken) => {
            fetch(`${REACT_APP_APIM_URL}/thermalimage/getNotificationConfiguration`, {
              method: "GET",
              headers: {
                Accept: "*/*",
                "Content-Type": "application/json",
                Authorization: "Bearer " + accessToken,
                "Access-Control-Allow-Origin": "*"
              },
            })
              .then((res) => res.json())
              .then(
                (resp) => {
                    this.props.setNotificationConfiguration(resp)
                    this.setTMTThreshold(resp)
                },
                (error) => {
                  console.log("error", error)
                }
              )
        })
    }

    getTMTInformation = () => {
        let newDate = ''
        if(this.props.selectedDate){
            let dateImg = new Date(this.props.selectedDate);
            getToken(this.props.auth).then((accessToken)=> {
                // newDate = dateImg.getFullYear() + "-" + ('0' + (dateImg.getMonth() + 1)).slice(-2) + "-" + ('0' + dateImg.getDate()).slice(-2) + "T" + ('0' + dateImg.getHours()).slice(-2) + ":" + ('0' + dateImg.getMinutes()).slice(-2)
                newDate = dateImg.toISOString().replace('Z', '');
                fetch(`${REACT_APP_APIM_URL}/thermalimage/getTMTInformation/${newDate}/${this.props?.currentFurnaceId}`, {
                    method: "GET",
                    headers: {
                        Accept: "*/*",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + accessToken,
                        "Access-Control-Allow-Origin": "*"
                    },
                })
                .then((res) => res.json())
                .then(
                    (resp) => {
                        let coilGroups = getCoilgroups(this.props?.currentFurnaceId);
                        coilGroups = coilGroups && coilGroups.filter((cg,i, cgs) => cgs.indexOf(cg) === i)
                        const furnaceCoilGroups: any[] = [];
                        coilGroups.forEach(x => {
                            furnaceCoilGroups.push(x.name)
                        });
                        this.props.setCoilgroups(furnaceCoilGroups)
                        let allCoilGroups = this.props.coilGroups
    
                        this.getTMTThreshold();
    
                        /*max of max_tmt over furnace cell start*/
                        let max_values = {}
                        let min_values = {}
                        
                        let cg_heat_distribution = this.state.cg_heat_distribution;
                        allCoilGroups.forEach(function (item, index) {
                            max_values[resp[item+"_maxCoilNumber"]] = resp[item+"_tmt_max"]
                            min_values[resp[item+"_minCoilNumber"]] = resp[item+"_tmt_min"]
                        });
                        let max_maxtmt_over_furnacecell = Object.keys(max_values).reduce((a, b) => max_values[a] > max_values[b] ? a : b);
                        /*max of max_tmt over furnace cell end*/
                        /*tmt threshold overshoot for specific coil group start*/
                        let thresholdDifferenceCoilgroups : string[] = [];
                        
                        allCoilGroups.forEach(function (item, index) {
                            const thresholdDifference = Math.abs(resp[item+"_tmt_max"] - resp[item+"_tmt_min"])
                            if(thresholdDifference > parseInt(cg_heat_distribution))
                            {
                                thresholdDifferenceCoilgroups.push(item)
                            }
                        });
                        /*tmt threshold overshoot for specific coil group end*/
                        /*tmt threshold overshoot for furnace cell start*/
                        let thresholdDifferenceFurnaceCell : string[] = []
                        if(Object.keys(max_values).length > 1){
                            let maxvalkey = Object.keys(max_values).reduce((a, b) => max_values[a] > max_values[b] ? a : b);
                            let minvalkey = Object.keys(max_values).reduce((a, b) => max_values[a] < max_values[b] ? a : b);
                            let max_maxtmt_val = max_values[maxvalkey]
                            let min_maxtmt_val = max_values[minvalkey]
                            if(Math.abs(max_maxtmt_val - min_maxtmt_val) > parseInt(this.state.furnace_heat_distribution))
                            {
                                thresholdDifferenceFurnaceCell.push(maxvalkey, minvalkey)
                            }
                        }
                        /*tmt threshold overshoot for furnace cell end*/
                        let coilDetails = []
                        allCoilGroups.forEach(function (item, index) {
                            coilDetails[item]={"tmt_min":resp[item+"_tmt_min"], "tmt_max":resp[item+"_tmt_max"], "minCoilNumber":resp[item+"_minCoilNumber"], "maxCoilNumber":resp[item+"_maxCoilNumber"],};
                        })
    
                        this.setState({
                            coil_details: coilDetails,
                            max_maxtmt_over_furnacecell: max_maxtmt_over_furnacecell,
                            tmt_threshold_overshoot_coilgroups: thresholdDifferenceCoilgroups,
                            tmt_threshold_overshoot_frunacecell: thresholdDifferenceFurnaceCell,
                            tmtBlockLoader: false
                        })
                    },
                    (error) => {
                        this.setState({tmtBlockLoader: false});
                        console.log("error", error)
                    }
                )
            })
        }
    }

    getRunlength = () => {
        let runLengthArr  = this.props.furnaces.furnace_metrics.filter((furnace) => furnace.furnace_id == this.props.furnaces.current_furnace_id)
        let runLength: number | string = runLengthArr.length > 0 ? runLengthArr[0]['Actual Runlength'] : 'N/A';
        return runLength
    }

    componentDidMount(): void {
        //this.getTMTThreshold();
        this.getTMTInformation()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedDate !== this.props.selectedDate || prevState.currCamera !== this.state.currCamera) {
            this.getTMTInformation()
            //this.getTMTThreshold()
        }
    }

    render(): React.ReactNode {

        return (
            <>
            {this.props.coilGroups.length > 0 ?
            <Paper elevation={3} className='TMTInfoBlock'>
                <div className="control-header element tmtgen">
                    <div className="container-typography tmtgen">                        
                        <Grid item direction="row" justifyContent="flex-start" xs={8} lg={10} xl={8} className="gen_display">
                                    <span className="cell_spacing tmt_furnace_header furnace_summary">Furnace Summary</span>
                                    <FurnaceSelector fromTMT="fromTMT" isFurnaceSelectionDisabled={this.props.isFurnaceSelectionDisabled}/>
                                    <span className="cell_spacing tmt_furnace_header">Run length(d) : </span>
                                    <span className="cell_spacing tmt_furnace_value">{this.getRunlength()}</span>
                                    <span className="cell_spacing tmt_furnace_header">Furnace Mode : </span>
                                    <span className="cell_spacing tmt_furnace_value">{isTMTCameraDeviation() ? this.state.furnace_mode : this.props.furnaces.furnaces[0].State}</span>
                        </Grid>
                    </div>
                </div>
                { this.state.tmtBlockLoader 
                    ?
                    <div className="loader-grid-parent" style={{height: "10vh"}}>
                        < div className="loader-grid">
                        <Loader />
                        <p> Loading...</p>
                        </div>
                    </div>
                : 
                <>
                    <Box width="100%" display="flex" justifyContent="left" alignItems="left">
                        <Grid item className="tmtBlockTable">
                            <Table className="tmt-table" >
                                <TableBody>
                                    <TableRow className="legend_border tmt_coil_bg">
                                        <TableCell className="legend_border cell_spacing bold th"></TableCell>
                                        {this.props.coilGroups.map((coil, i) => (
                                            <TableCell className="legend_border cell_spacing bold th" align="center" style={this.state.tmt_threshold_overshoot_frunacecell.some(str => str.includes(coil)) ? {backgroundColor: '#FFF241',color: "#435591"}:{color: "#435591"}} colSpan={2}>Coilgroup {coil}</TableCell>
                                        ))}
                                        <TableCell className="legend_border th cell_spacing tmt_white_bg" align="left" >Highest TMT in Furnace : </TableCell><TableCell  className="legend_border bold th cell_spacing tmt_furn_bg" style={{backgroundColor:'white'}} align="left"><span style={{border: '4px solid red',height: '100%',width: '100%',display: 'flex',marginLeft: '-4px'}}></span></TableCell>
                                    </TableRow>
                                    <TableRow className="legend_border tmt_bl_bg">
                                        <TableCell align="center" className="legend_border cell_spacing bold th tmt_lbl_bg">maxTMT</TableCell>
                                        {this.props.coilGroups.map((coil, i) => (
                                            <>
                                                <TableCell align="center" className="legend_border cell_spacing bold th tmt_lbl_bg">Value ({getTemperatureUnit()})</TableCell>
                                                <TableCell align="center" className="legend_border cell_spacing bold th tmt_lbl_bg">Coil Number</TableCell>
                                            </>
                                        ))}

                                        <TableCell className="legend_border th cell_spacing tmt_white_bg" align="left"><strong>Anomaly Events in Furnace Summary:</strong></TableCell>

                                    </TableRow>
                
                                    <TableRow className="legend_border tmt_coil_bg">
                                        <TableCell align="center" className="legend_border cell_spacing bold th tmt_lbl_bg">minimum</TableCell>
                                        {this.props.coilGroups.map((coil, i) => (
                                            <>
                                                <TableCell align="center" className="legend_border cell_spacing th" style={this.state.tmt_threshold_overshoot_coilgroups.includes(coil) ? { backgroundColor:'#ed7925'} : {}}>{ParseTemperatureValue(this.state.coil_details[coil]?.tmt_min)}</TableCell>
                                                <TableCell align="center" className="legend_border cell_spacing th">{this.state.coil_details[coil]?.minCoilNumber}</TableCell>
                                            </>
                                        ))}
                                        <TableCell className="legend_border th cell_spacing tmt_white_bg" align="left">CG Heat Distribution:</TableCell><TableCell className="legend_border bold th cell_spacing tmt_red_bg" align="left"
                                        >{this.state.cg_heat_distribution !== "" ? this.state.cg_heat_distribution+getTemperatureUnit() : ""}</TableCell>
                                        
                                    </TableRow>
                                    <TableRow className="legend_border tmt_bl_bg">
                                        <TableCell align="center" className="legend_border cell_spacing bold th tmt_lbl_bg">maximum</TableCell>
                                        {this.props.coilGroups.map((coil, i) => (
                                            <>
                                                <TableCell align="center" className="legend_border cell_spacing th" style={this.state.tmt_threshold_overshoot_coilgroups.includes(coil) ? { backgroundColor:'#ed7925'} : {}}>{ParseTemperatureValue(this.state.coil_details[coil]?.tmt_max)}</TableCell>
                                                <TableCell align="center" className="legend_border cell_spacing th" style={this.state.coil_details[coil] && this.state.coil_details[coil]?.maxCoilNumber === this.state.max_maxtmt_over_furnacecell && this.state.max_maxtmt_over_furnacecell !== "" ? { display:'block', border:'3px solid #F45858' } : {}}>{this.state.coil_details[coil]?.maxCoilNumber}</TableCell>
                                            </>
                                        ))}
                                        <TableCell className="legend_border cell_spacing tmt_white_bg" align="left" >Furnace Heat Distribution:</TableCell><TableCell className="legend_border bold th cell_spacing tmt_yel_bg" align="left">{this.state.furnace_heat_distribution !== "" ? this.state.furnace_heat_distribution+getTemperatureUnit() : ""}</TableCell>
                                        {/* <TableCell className="legend_border cell_spacing tmt_white_bg" align="left" >TMT Threshold:</TableCell>
                                        <TextField className="threshold_input" onChange={(e) => this.setState({tmt_threshold: e.target.value})} value={this.state.tmt_threshold+getTemperatureUnit()} disabled/> */}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </Box>
                </>
                }
                </Paper> : <></>}
            </>
        )
    }
}

export default withAuth(connector(withStyles(tmtStyles)(TmtInformationBlock)));